import React from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from './FadeIn';
export function Footer() {
  return <footer className="bg-cognarch-black pt-24 pb-12 border-t border-cognarch-charcoal relative overflow-hidden" data-id="element-63">
      <div className="max-w-7xl mx-auto px-6" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8 mb-20" data-id="element-65">
          <div className="md:col-span-5 lg:col-span-4" data-id="element-66">
            <FadeIn data-id="element-67">
              <Link to="/" data-id="element-68">
                <h2 className="text-3xl font-serif text-white mb-4 hover:text-white/80 transition-colors" data-id="element-69">
                  Cognarchism
                </h2>
              </Link>
              <p className="text-white/50 text-sm tracking-widest uppercase mb-8" data-id="element-70">
                Competence before power.
                <br data-id="element-71" />
                Judgment before rule.
                <br data-id="element-72" />
                Development before decay.
              </p>
            </FadeIn>
          </div>

          <div className="md:col-span-7 lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-12" data-id="element-73">
            <FadeIn delay={0.2} data-id="element-74">
              <h3 className="text-white font-medium mb-6 tracking-wide text-sm uppercase" data-id="element-75">
                Navigation
              </h3>
              <ul className="space-y-4" data-id="element-76">
                {[{
                label: 'Overview',
                to: '/overview'
              }, {
                label: 'NCJI',
                to: '/ncji'
              }, {
                label: 'Charter',
                to: '/charter'
              }, {
                label: 'Constitution',
                to: '/constitution'
              }, {
                label: 'About',
                to: '/about'
              }, {
                label: 'Contact',
                to: '/contact'
              }].map(link => <li key={link.label} data-id="element-77">
                    <Link to={link.to} className="text-white/50 hover:text-white transition-colors text-sm" data-id="element-78">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-79">
              <div className="bg-white/5 border border-white/10 p-6 rounded-sm relative" data-id="element-80">
                <div className="absolute -top-3 left-6 bg-cognarch-black px-2 text-xs text-white/40 tracking-widest uppercase" data-id="element-81">
                  The Creed
                </div>
                <p className="text-white/50 text-sm leading-relaxed font-serif italic" data-id="element-82">
                  "We hold these truths to be self-evident: That all minds are
                  capable of growth, but not all judgments are equal. That the
                  stability of the Republic depends on the discipline of the
                  Sovereign. That to lead is to have mastered oneself."
                </p>
              </div>
            </FadeIn>
          </div>
        </div>

        <FadeIn delay={0.4} data-id="element-83">
          <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-84">
            <p className="text-white/30 text-xs" data-id="element-85">
              &copy; {new Date().getFullYear()} The Cognarchism Project. All
              rights reserved.
            </p>
            <div className="flex gap-6 text-xs text-white/30" data-id="element-86">
              <Link to="/privacy" className="hover:text-white/60 transition-colors" data-id="element-87">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-white/60 transition-colors" data-id="element-88">
                Terms of Service
              </Link>
            </div>
          </div>
        </FadeIn>
      </div>
    </footer>;
}